/** Three-state resolution for a portal-builder customization string field
 * that has a legacy fallback source (branding images, per-page colors, text,
 * etc.).
 *
 *   - `""` in the new slot → intentionally cleared, do NOT fall back
 *   - non-empty string in the new slot → use as-is
 *   - `null` / `undefined` / missing in the new slot → inherit from legacy
 */
export function resolveCustomizationField(
  slot: string | null | undefined,
  legacy: string | null | undefined,
): string {
  if (slot === "") return "";
  if (slot) return slot;
  return legacy || "";
}

/** Same three-state resolution as `resolveCustomizationField` but returns
 * `undefined` when the field is cleared or missing — so image pickers can
 * render their empty state instead of a broken `<img src="">`. */
export function resolveCustomizationImage(
  slot: string | null | undefined,
  legacy: string | null | undefined,
): string | undefined {
  if (slot === "") return undefined;
  if (slot) return slot;
  return legacy || undefined;
}
